import React, { useContext, useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import { observer } from 'mobx-react-lite';
import { Context } from '../../index';

const AllUserPolls = observer(({onPoolSelect, setActiveComponent}) => {
    const { poolStore } = useContext(Context);

    const handleRowClick = (poll) => {
        poolStore.setSelectedPool(poll);
        onPoolSelect(poll);
        setActiveComponent('PoolFull');
    };

    return (
        <div className="card text-start align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
            <div className="mt-0">
                <h6 className="text-muted fst-italic">All Your Polls</h6>

                {/* 📱 Обёртка для адаптации */}
                <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '8px' }}>
                    <Table
                        striped
                        bordered
                        hover
                        size="sm"
                        className="shadow-sm rounded small mb-0"
                        style={{ minWidth: '890px' }} // минимальная ширина для корректного скролла
                    >
                        <thead className="table-light small text-muted">
                        <tr>
                            <th className="text-center fst-italic">#</th>
                            <th className="text-start fst-italic">Poll Name</th>
                            <th className="text-center fst-italic">Poll Type</th>
                            <th className="text-center fst-italic">Language</th>
                            <th className="text-center fst-italic">Created</th>
                            <th className="text-center fst-italic">Status</th>
                            <th className="text-center fst-italic">Audience</th>
                            <th className="text-center fst-italic">Searching</th>
                            <th className="text-center fst-italic">Ongoing</th>
                            <th className="text-center fst-italic">Compiled</th>
                        </tr>
                        </thead>
                        <tbody>
                        {poolStore?.currentUserPools?.map((poll, index) => (
                            <tr
                                className="small"
                                key={poll.id}
                                onClick={() => handleRowClick(poll)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td className="text-center fst-italic">{index + 1}</td>
                                <td className="text-start">{poll.name}</td>
                                <td className="text-center fst-italic">
                                    {{
                                        'COVER_POLL': 'Cover Poll',
                                        'TITLE_POLL': 'Title Poll',
                                        'COVER_TITLE_POLL': 'Cover & Title Poll',
                                        'DESCRIPTION_POLL': 'Description Poll',
                                        'MIXED_POLL': 'Mixed Poll'
                                    }[poll.pool_type] || 'Unknown'}
                                </td>
                                <td className="text-center fst-italic">{poll.language}</td>
                                <td className="text-center fst-italic">
                                    {new Date(poll.createdAt).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false,
                                    })}
                                </td>
                                <td className="text-center fst-italic">
                                    {{
                                        'LIVE': 'Ready to Run',
                                        'RUNNING': 'Running...',
                                        'ENDED': 'Ended',
                                        'COMPILING': 'Compiling',
                                    }[poll.status] || 'Unknown'}
                                </td>
                                <td className="text-muted text-center fst-italic">{poll.itemsCount || 0}</td>
                                <td className="text-muted text-center fst-italic">{poll.step0Count || 0}</td>
                                <td className="text-muted text-center fst-italic">{poll.step1Count || 0}</td>
                                <td className="text-muted text-center fst-italic">{poll.step2Count || 0}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );

});

export default AllUserPolls;
